import React from 'react';
import ReportingFnbPage from '../components/ReportingFnbPage';

const ReportingFnbApp = (props) => (
  <ReportingFnbPage {...props} />
);

export default ReportingFnbApp;
